import footerStyle from "./footer.module.scss";

import icn_dot_online from "assets/images/icons/icn_dot_online.svg";
import icn_dot_offline from "assets/images/icons/icn_dot_offline.svg";
import icn_dot_dormant from "assets/images/icons/icn_dot_dormant.svg";
import icn_dot_warning from "assets/images/icons/icn_dot_warning.svg";
import icn_topology_wired_line from "assets/images/icons/icn_topology_wired_line.svg";
import icn_topology_wired_line_high_traffic from "assets/images/icons/icn_topology_wired_line_high_traffic.svg";
import icn_topology_wireless_line from "assets/images/icons/icn_topology_wireless_line.svg";
import icn_topology_expand from "assets/images/icons/btn_topology_expand.svg";
import icn_topology_collapse from "assets/images/icons/btn_topology_collapse.svg";

import { Box, Typography } from "@mui/material";

const Footer = ({ treeIndex }) => {
  return (
    <Box className={footerStyle['footer']}>
      <Box className={footerStyle['item']}>
        <img src={icn_dot_online} alt="Online" />
        <Typography className={footerStyle['text']}>Online</Typography>
      </Box>
      <Box className={footerStyle['item']}>
        <img src={icn_dot_offline} alt="Offline" />
        <Typography className={footerStyle['text']}>Offline</Typography>
      </Box>
      {
        treeIndex !== -1 && (
          <>
            <Box className={footerStyle['item']}>
              <img src={icn_dot_dormant} alt="Dormant" />
              <Typography className={footerStyle['text']}>Dormant</Typography>
            </Box>
            <Box className={footerStyle['item']}>
              <img src={icn_dot_warning} alt="Warning" />
              <Typography className={footerStyle['text']}>Warning</Typography>
            </Box>
            <Box className={footerStyle['item']}>
              <img src={icn_topology_wired_line} alt="wired-line" />
              <Typography className={footerStyle['text']}>Wired Line</Typography>
            </Box>
            <Box className={footerStyle['item']}>
              <img src={icn_topology_wired_line_high_traffic} alt="wired-line-high-traffic" />
              <Typography className={footerStyle['text']}>Wired Line High Traffic</Typography>
            </Box>
            <Box className={footerStyle['item']}>
              <img src={icn_topology_wireless_line} alt="wireless-line" />
              <Typography className={footerStyle['text']}>Wireless Line</Typography>
            </Box>
            <Box className={footerStyle['item']}>
              <img src={icn_topology_expand} alt="expand" />
              <Typography className={footerStyle['text']}>Expand</Typography>
            </Box>
            <Box className={footerStyle['item']}>
              <img src={icn_topology_collapse} alt="collapse" />
              <Typography className={footerStyle['text']}>Collapse</Typography>
            </Box>
          </>
        )
      }
    </Box>
  );
}

export default Footer;